import "./Details.css";
import React, { Fragment, useEffect, useState, useRef } from "react";
import Input from "../../../components/Common/Input/Input";
import Select from "../../../components/Common/Select/Select";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";

import {
  AppBar,
  Button,
  Dialog,
  FormControl,
  IconButton,
  List,
  ListItem,
  Slide,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropertyFeatures from "../../../controllers/properties/PropertyFeatures";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";

// Form Validate imports Start
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ConfirmProperty from "../../../components/User/Properties/AddProperties/ConfirmProperty/ConfirmProperty";
import FormatPriceVerbal from "../../../helpers/FormatPriceVerbal";
import NumberFormat from "react-number-format";
// Form Validate imports End

// Form Validate schema Start
const schema = yup.object().shape({
  // interest: yup.bool().oneOf([true], "Interest is required").nullable(),
  status: yup.string().required("Interest is required").nullable(),
});
// Form Validate schema End

const Details = ({
  register,
  errors,
  watch,
  setValue,
  isStepVisited,
  LandUnits,
  CurrencySettings,
}) => {
  const [open, setOpen] = useState(false);
  const sampleData = new Array(7).fill("item name");
  const [area, setArea] = useState();
  const [propertyFeatures, setPropertyFeatures] = useState(null);

  // Form Validate const Start
  const optionsForm = { resolver: yupResolver(schema) };
  const { handleSubmit, setError, formState } = useForm(optionsForm);
  // Form Validate const End
  const topRef = useRef();
  useEffect(() => {
    async function fetchData() {
      let features = {};
      let { propertyFeatures } = await PropertyFeatures(
        getLocalStorageItem("bid")
      );

      /** Extract array of groups used in features */
      let GroupsArray = Array.from(
        new Set(propertyFeatures.map((item) => item["group"]))
      );

      /** Add features under their groups */
      GroupsArray.forEach((gr) => {
        features[gr] = []; // creation of array for every group
        /** Filters features of specific group and add under groups in feature object */
        propertyFeatures
          .filter(({ group }) => group === gr)
          .forEach((sf) => {
            features[gr] = [...features[gr], { ...sf }];
          });
      });

      setPropertyFeatures(features);
    }
    fetchData();
  }, []);

  const countFeatures = () => {
    const features = watch().features || null;
    if (features == null) return;
    let count = 0;
    Object.values(features).forEach(
      (group) => (count += Object.values(group).filter((value) => value).length)
    );
    return count;
  };

  const handleCheckBoxChange = (name) => {
    console.log(name);
    const val = watch(name);
    setValue(name, !val);
  };

  // useEffect(() => {
  //   setValue("landArea", "");
  //   setValue("landAreaLength", "");
  //   setValue("landAreaWidth", "");
  // }, [setValue, watch("landAreaUnit")]);
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    goToTop();
  }, []);

  return (
    <Fragment>
      {/* Property Title */}
      <label className="custom-field-title" ref={topRef}>
        Property Title <span style={{ color: "red" }}>*</span>
      </label>
      <Input
        name={"propertyTitle"}
        register={{
          ...register("propertyTitle", { required: true }),
        }}
        errors={isStepVisited() && errors}
        watch={watch}
        inputProps={{
          style: {
            textTransform: "capitalize",
            border: "1px solid lightgrey",
            borderRadius: "6px",
          },
        }}
      />

      {/* Rental/Selling Price */}
      <div className="row">
        {watch("availableForSale") && (
          <Fragment>
            <div className="col-6">
              <label className="custom-field-title">
                Selling Price <span style={{ color: "red" }}>*</span>
              </label>
              {/*<Input
                name={"sellingPrice"}
                register={{
                  ...register("sellingPrice", { required: true }),
                }}
                onChange={(e) => {
                  e.target.value > 0
                    ? setValue("sellingPrice", e.target.value)
                    : setValue("sellingPrice", "");
                }}
                errors={isStepVisited() && errors}
                selectedType="number"
                watch={watch}
              /> */}

              <TextField
                name="sellingPrice"
                type="number"
                className="bg-white w-100 my-2 mui-text-field"
                style={{ border: "1px solid lightgrey", borderRadius: "6px" }}
                {...register("sellingPrice", { required: true })}
                onChange={(e) => {
                  e.target.value >= 999999999999
                    ? setValue("sellingPrice", 999999999999)
                    : e.target.value < 0
                    ? setValue("sellingPrice", 0)
                    : setValue("sellingPrice", e.target.value);
                }}
                value={
                  watch("sellingPrice") < 0
                    ? 0
                    : watch("sellingPrice") >= 999999999999
                    ? watch("sellingPrice")
                    : watch("sellingPrice")
                }
                helperText={errors && errors["sellingPrice"]?.message}
                size="small"
                // inputProps={{ maxLength: 5 }}
                onInput={(e) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 12);
                }} // For maxLength 12
              />
            </div>
            <div className="col-6">
              <label className="custom-field-title">
                {/* Selling Price <span style={{ color: "red" }}>*</span> */}
              </label>
              <p
                style={{
                  color: "#4B4B4BE5",
                  margin: "24px 0px 0px 0px",
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                {watch("sellingPrice") > 0 &&
                  watch("sellingPrice") <= 999999999999 && (
                    <span>
                      {CurrencySettings.currency}
                      {`
                    ${
                      watch("sellingPrice") &&
                      watch("sellingPrice") > 0 &&
                      watch("sellingPrice") &&
                      watch("sellingPrice") <= 999999999999
                        ? FormatPriceVerbal(watch("sellingPrice"))
                        : ""
                    }
                    `}
                    </span>
                  )}

                <span
                  style={{
                    color: "#4e36a8",
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  {watch("sellingPrice") >= 1000000000
                    ? "The price you entered is too high"
                    : ""}
                </span>
              </p>
            </div>
          </Fragment>
        )}

        {watch("availableForRent") && (
          <Fragment>
            <div className="col-6">
              <label className="custom-field-title">
                Rental Price <span style={{ color: "red" }}>*</span>
              </label>
              {/* <Input
                name={"rentalPrice"}
                register={{
                  ...register("rentalPrice", { required: true }),
                }}
                errors={isStepVisited() && errors}
                selectedType="number"
                watch={watch}
              /> */}

              <TextField
                name="rentalPrice"
                type="number"
                style={{ border: "1px solid lightgrey", borderRadius: "6px" }}
                className="bg-white w-100 my-2 mui-text-field"
                {...register("rentalPrice", { required: true })}
                onChange={(e) => {
                  e.target.value >= 999999999999
                    ? setValue("rentalPrice", 999999999999)
                    : e.target.value < 0
                    ? setValue("rentalPrice", 0)
                    : setValue("rentalPrice", e.target.value);
                }}
                value={
                  watch("rentalPrice") < 0
                    ? 0
                    : watch("rentalPrice") >= 999999999999
                    ? watch("rentalPrice")
                    : watch("rentalPrice")
                }
                helperText={errors && errors["rentalPrice"]?.message}
                size="small"
                // inputProps={{ maxLength: 5 }}
                onInput={(e) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 12);
                }} // For maxLength 12
              />
            </div>
            <div className="col-6">
              <label className="custom-field-title">
                {/* Rental Price <span style={{ color: "red" }}>*</span> */}
              </label>
              <p
                style={{
                  color: "#4B4B4BE5",
                  margin: "24px 0px 0px 0px",
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                }}
              >
                {watch("rentalPrice") > 0 &&
                  watch("rentalPrice") <= 999999999999 && (
                    <span>
                      {CurrencySettings.currency}
                      {`
                    ${
                      watch("rentalPrice") &&
                      watch("rentalPrice") > 0 &&
                      watch("rentalPrice") &&
                      watch("rentalPrice") <= 999999999999
                        ? FormatPriceVerbal(watch("rentalPrice"))
                        : ""
                    }
                    `}
                    </span>
                  )}
                <span
                  style={{
                    color: "#4e36a8",
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  {watch("rentalPrice") >= 1000000000
                    ? "The price you entered is too high"
                    : ""}
                </span>
              </p>
            </div>
          </Fragment>
        )}
      </div>

      {/* Land Area */}
      <div className="row">
        {(watch("landAreaUnit") === "Marla" ||
          watch("landAreaUnit") === "Kanal") && (
          <div className="col-8">
            <label className="custom-field-title">
              Land Area <span style={{ color: "red" }}>*</span>
            </label>
            {/* <Input
            name={"landArea"}
            register={{
              ...register("landArea", {
                required: true,
              }),
            }}
            errors={isStepVisited() && errors}
            selectedType="number"
            watch={watch}
          /> */}

            <TextField
              name="landArea"
              type="number"
              style={{ border: "1px solid lightgrey", borderRadius: "6px" }}
              className="bg-white w-100 my-2 mui-text-field"
              {...register("landArea", { required: true })}
              onChange={(e) => {
                e.target.value >= 999999
                  ? setValue("landArea", 999999)
                  : e.target.value < 0
                  ? setValue("landArea", 0)
                  : setValue("landArea", e.target.value);
              }}
              value={
                watch("landArea") < 0
                  ? 0
                  : watch("landArea") >= 999999
                  ? watch("landArea")
                  : watch("landArea")
              }
              helperText={errors && errors["landArea"]?.message}
              size="small"
              onInput={(e) => {
                e.target.value = Math.max(0, parseInt(e.target.value))
                  .toString()
                  .slice(0, 6);
              }} // For maxLength 6
            />
          </div>
        )}

        {(watch("landAreaUnit") === "Square Feets" ||
          watch("landAreaUnit") === "Square Yards" ||
          watch("landAreaUnit") === "Square Meters") && (
          <Fragment>
            <div className="col-3" style={{ position: "relative" }}>
              <label className="custom-field-title">
                Length <span style={{ color: "red" }}>*</span>
              </label>
              {/* <Input
            name={"landArea"}
            register={{
              ...register("landArea", {
                required: true,
              }),
            }}
            errors={isStepVisited() && errors}
            selectedType="number"
            watch={watch}
          /> */}

              <TextField
                name="landAreaLength"
                type="number"
                className="bg-white w-100 my-2 mui-text-field"
                style={{ border: "1px solid lightgrey", borderRadius: "6px" }}
                {...register("landAreaLength", { required: true })}
                onChange={(e) => {
                  setValue("landAreaLength", e.target.value);
                  setValue("landArea", e.target.value * watch("landAreaWidth"));
                }}
                helperText={errors && errors["landAreaLength"]?.message}
                size="small"
                onInput={(e) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 6);
                }}
                placeholder="Length"
              />
              <span
                style={{ position: "absolute", top: "45px", right: "-5px" }}
              >
                X
              </span>
            </div>

            <div className="col-3">
              <label className="custom-field-title">
                Width <span style={{ color: "red" }}>*</span>
              </label>
              {/* <Input
            name={"landArea"}
            register={{
              ...register("landArea", {
                required: true,
              }),
            }}
            errors={isStepVisited() && errors}
            selectedType="number"
            watch={watch}
          /> */}

              <TextField
                name="landAreaWidth"
                type="number"
                className="bg-white w-100 my-2 mui-text-field"
                style={{ border: "1px solid lightgrey", borderRadius: "6px" }}
                {...register("landAreaWidth", { required: true })}
                onChange={(e) => {
                  setValue("landAreaWidth", e.target.value);
                  setValue(
                    "landArea",
                    e.target.value * watch("landAreaLength")
                  );
                }}
                helperText={errors && errors["landAreaWidth"]?.message}
                size="small"
                onInput={(e) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 6);
                }} // For maxLength 6
                placeholder="Width"
              />
            </div>

            <div
              className="col-2"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              {/* <TextField
                // name="landArea"
                type="number"
                className="bg-white w-100 my-2 mui-text-field disabled-land-area-input"
                // {...register("landArea", { required: true })}
                // onChange={(e) => {
                //   setValue("landAreaWidth", e.target.value);
                // }}
                // helperText={errors && errors["landAreaWidth"]?.message}
                size="small"
                // onInput={(e) => {
                //   e.target.value = Math.max(0, parseInt(e.target.value))
                //     .toString()
                //     .slice(0, 6);
                // }} // For maxLength 6
                value={watch("landAreaLength") * watch("landAreaWidth")}
                // placeholder="Width"
                disabled={true}
              /> */}

              <span className="disabled-land-area-input">
                {" "}
                ={" "}
                {isNaN(watch("landAreaLength") * watch("landAreaWidth"))
                  ? 0
                  : watch("landAreaLength") * watch("landAreaWidth")}
              </span>
            </div>
          </Fragment>
        )}

        <div className="col-4">
          <label className="custom-field-title">
            Unit <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            list={[
              "Square Feets",
              "Square Yards",
              "Square Meters",
              "Marla",
              "Kanal",
              ...LandUnits,
            ]}
            name={"landAreaUnit"}
            defaultValue={CurrencySettings.unit ?? "Marla"}
            register={{
              ...register("landAreaUnit", { required: true }),
            }}
            errors={isStepVisited() && errors}
            watch={watch}
          />
        </div>
      </div>

      {/* Land Area */}
      {watch("propertyType") !== "Plot" &&
        watch("propertySubType") !== "Shop" && (
          <div className="row">
            <div className="col-6">
              <label className="custom-field-title">
                Bedrooms <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                list={[
                  "Studio",
                  "0",
                  "1",
                  "2",
                  "3",
                  "4",
                  "5",
                  "6",
                  "7",
                  "8",
                  "9",
                  "10",
                  "10+",
                ]}
                name={"bedrooms"}
                register={{
                  ...register("bedrooms", { required: true }),
                }}
                errors={isStepVisited() && errors}
                watch={watch}
              />
            </div>
            <div className="col-6">
              <label className="custom-field-title">
                Bathrooms <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                list={[
                  "0",
                  "1",
                  "2",
                  "3",
                  "4",
                  "5",
                  "6",
                  "7",
                  "8",
                  "9",
                  "10",
                  "10+",
                ]}
                name={"bathrooms"}
                register={{
                  ...register("bathrooms", { required: true }),
                }}
                errors={isStepVisited() && errors}
                watch={watch}
              />
            </div>
          </div>
        )}
      <br></br>
      <br></br>
      {/* Confirm Property */}
      <label className="custom-field-title">Given details are confirmed?</label>
      <div className="row">
        <div className="col-12">
          <span>
            <ConfirmProperty
              status={"Confirm property"}
              type={"checkbox"}
              style={{ lineHeight: 32 }}
              name="confirm"
              register={{
                ...register("confirm-property", {
                  required: true,
                }),
              }}
              errors={isStepVisited() && errors}
              watch={watch}
              isStepVisited={isStepVisited}
            />
          </span>
        </div>
      </div>

      {/* Description */}
      <div className="form-group col-12 p-0 mt-3">
        <FormControl fullWidth>
          <label className="custom-field-title">Description </label>
          <TextField
            name="description"
            variant="outlined"
            className="property-description"
            multiline
            style={{
              width: "100%",
              border: "1px solid lightgrey",
              borderRadius: "6px",
            }}
            rows={10}
            {...register("description")}
            value={area}
            onChange={(e) => {
              let val =
                e.target.value?.charAt(0).toUpperCase() +
                e.target.value.slice(1);
              setArea(val);
            }}
            errors={isStepVisited() && errors}
          />
        </FormControl>
      </div>

      {/* Features */}

      {propertyFeatures && (
        <Features
          open={open}
          setOpen={(val) => setOpen(val)}
          features={propertyFeatures}
          register={register}
          watch={watch}
          handleCheckBoxChange={handleCheckBoxChange}
        />
      )}
    </Fragment>
  );
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Features = ({
  open,
  setOpen,
  features,
  register,
  watch,
  handleCheckBoxChange,
}) => {
  const groups = Object.keys(features);
  return (
    <Fragment>
      <List>
        <div className="container">
          <h4 className="card-title pt-1 featureTitle">Features</h4>
          {features &&
            groups.map((gr) => {
              const GroupName = gr
                .split("-")
                .map((word) => word[0].toLocaleUpperCase() + word.substring(1))
                .join(" ");
              const groupFeatures = features[gr];
              return (
                <Fragment>
                  {GroupName === "ExtraFeatures" && (
                    <h4 className="card-title pt-1 featureTitle">
                      {GroupName === "ExtraFeatures" ? "Extra Features" : ""}
                    </h4>
                  )}
                  <Fragment>
                    <ListItem style={{ display: "contents" }}>
                      <Box className="d-flex  row">
                        {groupFeatures.map(
                          ({ group, icon, label, type, value }) => {
                            const registerName = `features.${group}.${value}`;
                            return (
                              <div className="col-12 col-xl-6  mb-1">
                                <div
                                  onClick={() =>
                                    handleCheckBoxChange(registerName)
                                  }
                                  className="property-features-element"
                                >
                                  <div>
                                    <input
                                      type="checkbox"
                                      checked={watch(registerName) || false}
                                      {...register(registerName)}
                                      className="mr-2"
                                    />
                                  </div>
                                  <p className="property-features-text">
                                    {label}
                                  </p>
                                  <i className={`${icon} iconPosition`}></i>
                                </div>
                                {/* <Paper
                                  elevation={0}
                                  onClick={() =>
                                    handleCheckBoxChange(registerName)
                                  }
                                  className={"c-pointer border border-1"}
                                  style={{
                                    borderColor: "rgba(200,200,200,.4)",
                                  }}
                                >
                                  <Typography variant="overline" gutterBottom>
                                    <Checkbox
                                      className="checkboxPosition"
                                      color="success"
                                      checked={watch(registerName) || false}
                                      {...register(registerName)}
                                    />
                                    <span className="property-features-text">
                                      {label}
                                    </span>

                                    <i className={`${icon} iconPosition`}></i>
                                  </Typography>
                                </Paper> */}
                              </div>
                            );
                          }
                        )}
                      </Box>
                    </ListItem>
                  </Fragment>
                </Fragment>
              );
            })}
        </div>
      </List>
    </Fragment>
  );
};
const FeaturesDialog = ({ open, setOpen, features, register, watch }) => {
  const groups = Object.keys(features);
  return (
    <Fragment>
      {features && (
        <Dialog
          fullScreen
          open={open}
          onClose={() => setOpen(false)}
          TransitionComponent={Transition}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar style={{ backgroundColor: "#203CC5" }}>
              {/* <CloseIcon /> */}
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => setOpen(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Sound
              </Typography>
              <Button autoFocus color="inherit" onClick={() => setOpen(false)}>
                save
              </Button>
            </Toolbar>
          </AppBar>
          <List>
            <div className="container mt-5 pt-2">
              {features &&
                groups.map((gr) => {
                  const GroupName = gr
                    .split("-")
                    .map(
                      (word) => word[0].toLocaleUpperCase() + word.substring(1)
                    )
                    .join(" ");
                  const groupFeatures = features[gr];
                  return (
                    <Fragment>
                      <h4 className="card-title pt-1 featureTitle">
                        {GroupName}
                      </h4>
                      <Fragment>
                        <ListItem style={{ display: "contents" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              "& > :not(style)": {
                                m: 1,
                                width: 350,
                                height: 50,
                              },
                            }}
                          >
                            {groupFeatures.map(
                              ({ group, icon, label, type, value }) => {
                                const registerName = `features.${group}.${value}`;
                                return (
                                  <Paper elevation={3}>
                                    <Typography variant="overline" gutterBottom>
                                      <Checkbox
                                        className="checkboxPosition"
                                        color="success"
                                        checked={watch(registerName) || false}
                                        {...register(registerName)}
                                      />
                                      {label}
                                      <i className={`${icon} iconPosition`}></i>
                                    </Typography>
                                  </Paper>
                                );
                              }
                            )}
                          </Box>
                        </ListItem>
                      </Fragment>
                    </Fragment>
                  );
                })}
            </div>
          </List>
        </Dialog>
      )}
    </Fragment>
  );
};

export default Details;
